export function getInvoiceLinksLabel(orderType, count) {
  const qty = Number(count);
  const isPlural = qty !== 1;

  switch (orderType) {
    case "normal":
      return isPlural ? "Backlinks" : "Backlink";
    case "missed_opportunity":
      return isPlural ? "Premium Links" : "Premium Link";
    case "media_placement":
      return isPlural ? "Media Links" : "Media Link";
    case "brand_mention":
      return isPlural ? "Brand Mentions" : "Brand Mention";
    default:
      return "Total Links";
  }
}
